
import axios from "axios";
import { Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField } from "@mui/material";
import React, { useState } from "react";
import UrlIcon from '@mui/icons-material/AdsClick';
import { Table, TableHead, TableBody, TableRow, TableCell, Paper, TableContainer } from '@mui/material';
 




 
import 'dayjs/locale/pt-br';
import { ptBR } from '@mui/x-date-pickers/locales';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
 

import ST from '../images/Rosca/ST.png';
import STr from '../images/Rosca/STr.png';
import SD from '../images/Rosca/SD.png';
import SDr from '../images/Rosca/SDr.png';
import SC from '../images/Rosca/SC.png';
import SEr from '../images/Rosca/SEr.png';
import SE from '../images/Rosca/SE.png';
import SIr from '../images/Rosca/SIr.png';
import SI from '../images/Rosca/SI.png';
import STb from '../images/Rosca/STb.png';
import SDb from '../images/Rosca/SDb.png';
import SEb from '../images/Rosca/SEb.png';
import SIb from '../images/Rosca/SIb.png';

//TRINCA IMAGEM
import Trinca from '../images/Rosca/Trinca.png';
import SBF7 from '../images/Rosca/SBF7.png';
import SDF7 from '../images/Rosca/SDF7.png';
import STF7 from '../images/Rosca/STF7.png';
import SEF7 from '../images/Rosca/SEF7.png';

//CORROSÃO IMAGEM
import Corrosao from '../images/Rosca/Corrosao.png';
import SBF8 from '../images/Rosca/SBF8.png';
import SDF8 from '../images/Rosca/SDF8.png';
import STF8 from '../images/Rosca/STF8.png';
import SEF8 from '../images/Rosca/SEF8.png';

//CORROSÃO POROS
import Poros from '../images/Rosca/Poros.png';
import SBF9 from '../images/Rosca/SBF9.png';
import SDF9 from '../images/Rosca/SDF9.png';
import STF9 from '../images/Rosca/STF9.png';
import SEF9 from '../images/Rosca/SEF9.png';

//CORROSÃO ABAULAMENTOS
import Abaulamentos from '../images/Rosca/Abaulamentos.png';
import SBF10 from '../images/Rosca/SBF10.png';
import SDF10 from '../images/Rosca/SDF10.png';
import STF10 from '../images/Rosca/STF10.png';
import SEF10 from '../images/Rosca/SEF10.png';

import GreenOK from '../images/Rosca/GreenDocsOK.png';
import GreenNO from '../images/Rosca/GreenDocsNO.png';


import '../css/rosca.css';
 
 

type Props = {};

const Bidimensional = (props: Props) => {
  const [partes, setPartes] = useState<{ parte: string; textura: string, infoEspe: string }[]>([]);

  const headers = ['0º', '90º', '180º', '270º'];
  
  const [files, setFiles] = useState<File[]>([])
  const [erro, setErro] = useState<string>("");

  
  const [selectedValue, setSelectedValue] = useState('antiga');
  const [urlrelatorio, setUrlRelatorio] = useState<string>('');
  const [urlrelatorioNR13, setUrlRelatorioNR13] = useState<string>('');
  const [dataInspecao, setDataInspecao] = useState<Dayjs | null>(null);
   const [mostraTextoSolte, setMostraTextoSolte] = useState(false);


  const [helicoide1Data, setHelicoide1Data] = useState<{
    local: string;
    valores: number[][];
  }>({
    local: "Helicoide1",
    valores: Array.from({ length: 3 }, () => Array(4).fill(0.0))
  });


  const [helicoide2Data, setHelicoide2Data] = useState<{
    local: string;
    valores: number[][];
  }>({
    local: "Helicoide2",
    valores: Array.from({ length: 3 }, () => Array(4).fill(0.0))
  });

  const [helicoide3Data, setHelicoide3Data] = useState<{
    local: string;
    valores: number[][];
  }>({
    local: "Helicoide3",
    valores: Array.from({ length: 3 }, () => Array(4).fill(0.0))
  });

  const [helicoide4Data, setHelicoide4Data] = useState<{
    local: string;
    valores: number[][];
  }>({
    local: "Helicoide4",
    valores: Array.from({ length: 3 }, () => Array(4).fill(0.0))
  });


  const [helicoide5Data, setHelicoide5Data] = useState<{
    local: string;
    valores: number[][];
  }>({
    local: "Helicoide5",
    valores: Array.from({ length: 3 }, () => Array(4).fill(0.0))
  });

  const [helicoide6Data, setHelicoide6Data] = useState<{
    local: string;
    valores: number[][];
  }>({
    local: "Helicoide6",
    valores: Array.from({ length: 3 }, () => Array(4).fill(0.0))
  });



 
  const [preview, setPreview] = useState<string | null>(null);
 

  dayjs.locale('pt-br');


  const [selecionado, setSelecionado] = useState<string>('');
  const [informacoesEspecificas, setInformacoesEspecificas] = useState<string>('');
  const [infoEspe, setInfoEspe] = useState<string>('');
  const LAs = [
    "Parte1", "Parte2", "Parte3", "Parte4", "Parte5", "Parte6", "Parte7", "Parte8", "Parte9", "Parte10",
    "Parte11", "Parte12", "Parte13", "Parte14", "Parte15", "Parte16", "Parte17", "Parte18", "Parte19", "Parte20",
    "Parte21", "Parte22", "Parte23", "Parte24", "Parte25", "Parte26", "Parte27", "Parte28", "Parte29", "Parte30",
    "Parte31", "Parte32", "Parte33", "Parte34", "Parte35", "Parte36", "Parte37", "Parte38", "Parte39", "Parte40",
    "Parte41", "Parte42", "Parte43", "Parte44", "Parte45", "Parte46", "Parte47", "Parte48", "Parte49", "Parte50",
    "Parte51", "Parte52", "Parte53", "Parte54", "Parte55", "Parte56", "Parte57", "Parte58", "Parte59", "Parte60",
    "Parte61", "Parte62", "Parte63", "Parte64", "Parte65", "Parte66", "Parte67", "Parte68", "Parte69", "Parte70",
    "Parte71", "Parte72", "Parte73", "Parte74", "Parte75", "Parte76", "Parte77", "Parte78", "Parte79", "Parte80",
    "Parte81", "Parte82", "Parte83", "Parte84", "Parte85", "Parte86", "Parte87", "Parte88", "Parte89", "Parte90",
    "Parte139", "Parte140", "Parte141", "Parte142"
  ];

const token = localStorage.getItem("token");

console.log("Token JWT sendo enviado:", token);

  const cimaCinza = ["la1", "lc1", "le1", "lg1", "li1", "lk1"];
  const cimaRoxo = ["lb1", "ld1", "lf1", "lh1", "lj1", "ll1", "lm1"];
  const cima = [...cimaCinza, ...cimaRoxo];


  const esquerdaCinza = ["la2", "lc2", "le2", "lg2", "li2", "lk2"];
  const esqueraRoxo = ["lb2", "ld2", "lf2", "lh2", "lj2", "ll2", "lm2"]
  const esquerda = [...esqueraRoxo, ...esquerdaCinza];




  const direitaCinza = ["la4", "lc4", "le4", "lg4", "li4", "lk4"];
  const direitaRoxo = ["lb4", "ld4", "lf4", "lh4", "lj4", "ll4", "lm4"];
  const direita = [...direitaCinza, ...direitaRoxo];



  const baixoCinza = ["la5", "lc5", "le5", "lg5", "li5", "lk5"];
  const baixoRoxo = ["lb5", "ld5", "lf5", "lh5", "lj5", "ll5", "lm5"];
  const baixo = [...baixoCinza, ...baixoRoxo];

 const [dragActive, setDragActive] = useState(false);

 const handleEnviar = async () => {
  if (partes.length > 0) {
    try {
      const formData = new FormData();
console.log("Token JWT sendo enviado:", token);
      // Adiciona dados simples
      formData.append("urlrelatorio", urlrelatorio);
      formData.append("urlrelatorioNR13", urlrelatorioNR13);
      formData.append("status", selectedValue);
      formData.append("dataInspecao", dataInspecao?.toISOString() || "");

      // Adiciona os arquivos PNG ao formData
      files.forEach((file) => {
        formData.append("arquivos", file); 
      });

      // Converte partes (objeto ou array) em JSON string
      formData.append("partes", JSON.stringify(partes));


      formData.append("helicoide1", JSON.stringify(helicoide1Data));
      formData.append("helicoide2", JSON.stringify(helicoide2Data));
      formData.append("helicoide3", JSON.stringify(helicoide3Data));
      formData.append("helicoide4", JSON.stringify(helicoide4Data));
      formData.append("helicoide5", JSON.stringify(helicoide5Data));
      formData.append("helicoide6", JSON.stringify(helicoide6Data));

//
        const response = await axios.post(
  `${process.env.REACT_APP_API_URL}/rosca/upload`,
  formData,
  {
    
  
  withCredentials: true,
   headers: {
    'Content-Type': 'multipart/form-data'
  }
    },
  
);





      {alert("Dados registrados com sucesso!!")}
      console.log("Dados enviados com sucesso:", response.data);
      window.location.reload();
    } catch (error) {
      console.error("Erro ao enviar dados:", error);
    }
  } else {
    console.warn("Não há informações para enviar.");
  }
};


const handleCellChangeHel1 = (
  rowIndex: number,
  cellIndex: number,
  value: string
) => {
  const updatedValores = helicoide1Data.valores.map((row, rIdx) =>
    rIdx === rowIndex
      ? row.map((cell, cIdx) => (cIdx === cellIndex ? parseFloat(value) || 0 : cell))
      : row
  );

  setHelicoide1Data((prev) => ({
    ...prev,
    valores: updatedValores as number[][]
  }));
};

const handleCellChangeHel2 = (
  rowIndex: number,
  cellIndex: number,
  value: string
) => {
  const updatedValores = helicoide2Data.valores.map((row, rIdx) =>
    rIdx === rowIndex
      ? row.map((cell, cIdx) =>
          cIdx === cellIndex ? parseFloat(value) || 0 : cell
        )
      : row
  );

  setHelicoide2Data((prev) => ({
    ...prev,
    valores: updatedValores as number[][]
  }));
};

const handleCellChangeHel3 = (
  rowIndex: number,
  cellIndex: number,
  value: string
) => {
  const updatedValores = helicoide3Data.valores.map((row, rIdx) =>
    rIdx === rowIndex
      ? row.map((cell, cIdx) =>
          cIdx === cellIndex ? parseFloat(value) || 0 : cell
        )
      : row
  );

  setHelicoide3Data((prev) => ({
    ...prev,
    valores: updatedValores as number[][]
  }));
};



const handleCellChangeHel4 = (
  rowIndex: number,
  cellIndex: number,
  value: string
) => {
  const updatedValores = helicoide4Data.valores.map((row, rIdx) =>
    rIdx === rowIndex
      ? row.map((cell, cIdx) =>
          cIdx === cellIndex ? parseFloat(value) || 0 : cell
        )
      : row
  );

  setHelicoide4Data((prev) => ({
    ...prev,
    valores: updatedValores as number[][]
  }));
};


const handleCellChangeHel5 = (
  rowIndex: number,
  cellIndex: number,
  value: string
) => {
  const updatedValores = helicoide5Data.valores.map((row, rIdx) =>
    rIdx === rowIndex
      ? row.map((cell, cIdx) =>
          cIdx === cellIndex ? parseFloat(value) || 0 : cell
        )
      : row
  );

  setHelicoide5Data((prev) => ({
    ...prev,
    valores: updatedValores as number[][]
  }));
};



const handleCellChangeHel6 = (
  rowIndex: number,
  cellIndex: number,
  value: string
) => {
  const updatedValores = helicoide6Data.valores.map((row, rIdx) =>
    rIdx === rowIndex
      ? row.map((cell, cIdx) =>
          cIdx === cellIndex ? parseFloat(value) || 0 : cell
        )
      : row
  );

  setHelicoide6Data((prev) => ({
    ...prev,
    valores: updatedValores as number[][]
  }));
};



 



  const handleURL = (event: React.ChangeEvent<HTMLInputElement>) => {
    const imgElementGreen = document.getElementById("Green1") as HTMLImageElement;
    const imgElementNR = document.getElementById("Green2") as HTMLImageElement;
    const valorDigitado = event.target.value;
    const id = event.target.id;
    const urlBase = "https://eldoradobrasil.greendocs.net/";


    console.log("URL válida:", valorDigitado);

    console.log("URL válida:", urlBase); 


    // Verifica se o valor digitado contém a URL base e Relatorio Green
    if (valorDigitado.includes(urlBase) && id === 'Green' ) {
      setErro(""); // Remove qualquer erro anterior
      setUrlRelatorio(valorDigitado);
      imgElementGreen.src = GreenOK;
      console.log("URL válida:", valorDigitado);
    } else {
      setErro(`A URL precisa conter: ${urlBase}`);
     
    }


    // Verifica se o valor digitado contém a URL base e Relatorio Green
    if (valorDigitado.includes(urlBase) && id === 'NR13Greendocs' ) {
    setErro(""); // Remove qualquer erro anterior
    setUrlRelatorioNR13(valorDigitado);
    imgElementNR.src = GreenOK;
    console.log("URL válida:", valorDigitado);
    } else {
      setErro(`A URL precisa conter: ${urlBase}`);
    

    }


   

  };
  

  const onFileDropped = (file: File) => {
    // Exemplo: gerar URL para pré‑visualização
    const url = URL.createObjectURL(file);
    setPreview(url);

    // ou: enviar ao servidor
    // uploadService.send(file);
  };

 const handleDragOver = (event: React.DragEvent) => {
    event.preventDefault();
    setDragActive(true);
    setMostraTextoSolte(true);
  };

  const handleDragLeave = (event: React.DragEvent) => {
    event.preventDefault();
    setMostraTextoSolte(false);
  };

  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault();
    setDragActive(true); // mantém verde
    setMostraTextoSolte(false); // volta texto
    const files1 = event.dataTransfer.files;
    if (files1 && files1.length > 0) {
      
 setFiles(Array.from(files1));
console.log('Arquivo recebido:', files[0]);
    }
  };






  const handleChange = (event: any) => {
    setSelectedValue(event.target.value);
    
  };

  const handleCliqueDireito = (e: React.MouseEvent<HTMLDivElement>, parte: string) => {
    e.preventDefault();
    const imgElement = document.getElementById(parte) as HTMLImageElement;
    setSelecionado('');
    removerUltimoRegistro();
    imgElement.src = imgElement.src.includes("STb.png") ? ST : ST;
    console.log("!!!!" + partes)
  };

  //Selciona a Parte da Helicóide
  const handleSelecionarParte = (param: string) => {
    console.log('Estado atualizado de informacoes:', partes);
    const imgElement = document.getElementById(param) as HTMLImageElement;
    

    if (selecionado == '') {

      setInformacoesEspecificas(param);
      if (cima.includes(imgElement.id)) {

        setSelecionado(param);
        imgElement.src = imgElement.src.includes("STb.png") ? ST : STb;
      }
      if (esquerda.includes(imgElement.id)) {

        setSelecionado(param);
        imgElement.src = imgElement.src.includes("SDb.png") ? SD : SDb;
      }
      if (direita.includes(imgElement.id)) {

        setSelecionado(param);
        imgElement.src = imgElement.src.includes("SEb.png") ? SE : SEb;
      }
      if (baixo.includes(imgElement.id)) {

        setSelecionado(param);
        imgElement.src = imgElement.src.includes("SIb.png") ? SI : SIb;
      }

      if (LAs.includes(imgElement.id)) {
        console.log('Estado atualizado de informacoes:', param);
        setSelecionado(param);
        imgElement.style.backgroundColor = "blue";

      }


    }

  };

  const handleAbaulamento = (param: string) => {
    const imgElement = document.getElementById(selecionado) as HTMLImageElement;
    if (cima.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("STb.png") ? STF10 : STF10;
      gravarInformacoes(selecionado, param);

    }
    if (esquerda.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("SDb.png") ? SDF10 : SDF10;
      gravarInformacoes(selecionado, param);
    }
    if (direita.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("SEb.png") ? SEF10 : SEF10;
      gravarInformacoes(selecionado, param);
    }
    if (baixo.includes(imgElement.id)) {


      imgElement.src = imgElement.src.includes("SIb.png") ? SBF10 : SBF10;
      gravarInformacoes(selecionado, param);
    }

    if (LAs.includes(imgElement.id)) {


      imgElement.style.backgroundImage = `url(${Abaulamentos})`;
      gravarInformacoes(selecionado, param);
    }



  }



  const handlePoros = (param: string) => {
    const imgElement = document.getElementById(selecionado) as HTMLImageElement;
    if (cima.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("STb.png") ? STF9 : STF9;
      gravarInformacoes(selecionado, param);

    }
    if (esquerda.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("SDb.png") ? SDF9 : SDF9;
      gravarInformacoes(selecionado, param);
    }
    if (direita.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("SEb.png") ? SEF9 : SEF9;
      gravarInformacoes(selecionado, param);
    }
    if (baixo.includes(imgElement.id)) {


      imgElement.src = imgElement.src.includes("SIb.png") ? SBF9 : SBF9;
      gravarInformacoes(selecionado, param);
    }

    if (LAs.includes(imgElement.id)) {

     
      imgElement.style.backgroundImage = `url(${Poros})`;
      gravarInformacoes(selecionado, param);
    }


  }


  const handleCorrosao = (param: string) => {
    const imgElement = document.getElementById(selecionado) as HTMLImageElement;
    if (cima.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("STb.png") ? STF8 : STF8;
      gravarInformacoes(selecionado, param);

    }
    if (esquerda.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("SDb.png") ? SDF8 : SDF8;
      gravarInformacoes(selecionado, param);
    }
    if (direita.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("SEb.png") ? SEF8 : SEF8;
      gravarInformacoes(selecionado, param);
    }
    if (baixo.includes(imgElement.id)) {


      imgElement.src = imgElement.src.includes("SIb.png") ? SBF8 : SBF8;
      gravarInformacoes(selecionado, param);
    }

    if (LAs.includes(imgElement.id)) {

      console.log("@@@@@");
      imgElement.style.backgroundImage = `url(${Corrosao})`;
      gravarInformacoes(selecionado, param);
    }

  }

  const handleTrinca = (param: string) => {

    const imgElement = document.getElementById(selecionado) as HTMLImageElement;

    if (cima.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("STb.png") ? STF7 : STF7;
      gravarInformacoes(selecionado, param);
      console.log('Estado atualizado de informacoes:', partes);

    }
    if (esquerda.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("SDb.png") ? SDF7 : SDF7;
      gravarInformacoes(selecionado, param);
      console.log('Estado atualizado de informacoes:', partes);
    }
    if (direita.includes(imgElement.id)) {

      imgElement.src = imgElement.src.includes("SEb.png") ? SEF7 : SEF7;
      gravarInformacoes(selecionado, param);
      console.log('Estado atualizado de informacoes:', partes);
    }
    if (baixo.includes(imgElement.id)) {


      imgElement.src = imgElement.src.includes("SIb.png") ? SBF7 : SBF7;
      gravarInformacoes(selecionado, param);
      console.log('Estado atualizado de informacoes:', partes);
    }

    if (LAs.includes(imgElement.id)) {


      imgElement.style.backgroundImage = `url(${Trinca})`;
      gravarInformacoes(selecionado, param);
      console.log("Estado atual de informacoes:",partes);
    }



  };
 
 
  //Ok funcionando
  const gravarInformacoes = (parte: string, textura: string) => {


    


    const novoRegistro = { parte, textura, infoEspe }; // Ajusta as chaves para o tipo esperado
    const novoEstado = [...partes, novoRegistro];
    console.log("Novo estado (auxiliar):", novoEstado);
    setPartes(novoEstado);


    //setInformacoes((prevInformacoes) => [...prevInformacoes, novoRegistro]); // Adiciona o novo registro
    setSelecionado('');
    setInfoEspe('');
   
  };
 

 


  const removerUltimoRegistro = () => {

    setPartes((prevInformacoes) =>
      prevInformacoes.filter((registro) => registro.parte !== selecionado)
    );
    console.log(
      "Estado atual de informacoes após remoção:",
      partes.filter((registro) => registro.parte !== selecionado)
    );
  };
 





  return (
    <div>

      <br/><br/><br/><br/>
      <div className="containerR1">
        {/*Classe terminando com 1*/}
        <div className="la1" onClick={() => handleSelecionarParte("la1")} onContextMenu={(e) => handleCliqueDireito(e, "la1")}>

          <img src={ST} id="la1" alt="Imagem 1" width="30" height="30" />
        </div>

        <div className="lb1" onClick={() => handleSelecionarParte("lb1")}>
          <img src={STr} id="lb1" alt="Imagem 1" width="30" height="30" />
        </div>
        <div className="lc1" onClick={() => handleSelecionarParte("lc1")}>
          <img src={ST} id="lc1" alt="Imagem 1" width="30" height="30" />
        </div>
        <div className="ld1" onClick={() => handleSelecionarParte("ld1")}>
          <img src={STr} id="ld1" alt="Imagem 1" width="30" height="30" />
        </div>
        <div className="le1" onClick={() => handleSelecionarParte("le1")}>
          <img src={ST} id="le1" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lf1" onClick={() => handleSelecionarParte("lf1")}>
          <img src={STr} id="lf1" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lg1" onClick={() => handleSelecionarParte("lg1")}>
          <img src={ST} id="lg1" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lh1" onClick={() => handleSelecionarParte("lh1")}>
          <img src={STr} id="lh1" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="li1" onClick={() => handleSelecionarParte("li1")}>
          <img src={ST} id="li1" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lj1" onClick={() => handleSelecionarParte("lj1")}>
          <img src={STr} id="lj1" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lk1" onClick={() => handleSelecionarParte("lk1")}>
          <img src={ST} id="lk1" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lm1" onClick={() => handleSelecionarParte("lm1")}>
          <img src={STr} id="lm1" alt="Imagem 1" width="30" height="30" className="center" />
        </div>

        {/* Classe terminando com 2 (sem modificações) */}
        <div className="la2" onClick={() => handleSelecionarParte("la2")}>
          <img src={SD} id="la2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lb2" onClick={() => handleSelecionarParte("lb2")}>
          <img src={SDr} id="lb2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lc2" onClick={() => handleSelecionarParte("lc2")}>
          <img src={SD} id="lc2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="ld2" onClick={() => handleSelecionarParte("ld2")}>
          <img src={SDr} id="ld2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="le2" onClick={() => handleSelecionarParte("le2")}>
          <img src={SD} id="le2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lf2" onClick={() => handleSelecionarParte("lf2")}>
          <img src={SDr} id="lf2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lg2" onClick={() => handleSelecionarParte("lg2")}>
          <img src={SD} id="lg2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lh2" onClick={() => handleSelecionarParte("lh2")}>
          <img src={SDr} id="lh2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="li2" onClick={() => handleSelecionarParte("li2")}>
          <img src={SD} id="li2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lj2" onClick={() => handleSelecionarParte("lj2")}>
          <img src={SDr} id="lj2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lk2" onClick={() => handleSelecionarParte("lk2")}>
          <img src={SD} id="lk2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lm2" onClick={() => handleSelecionarParte("lm2")}>
          <img src={SDr} id="lm2" alt="Imagem 1" width="30" height="30" className="center" />
        </div>


        { /** Classe terminando com 3 */}
        <div className="la3" onClick={() => handleSelecionarParte("la3")}>
          <img src={SC} id="la3" alt="Imagem 3" className="center" />
        </div>
        <div className="lb3" onClick={() => handleSelecionarParte("lb3")}>
          <img src={SC} id="lb3" alt="Imagem 3" className="center" />
        </div>
        <div className="lc3" onClick={() => handleSelecionarParte("lc3")}>
          <img src={SC} id="lc3" alt="Imagem 3" className="center" />
        </div>
        <div className="ld3" onClick={() => handleSelecionarParte("ld3")}>
          <img src={SC} id="ld3" alt="Imagem 3" className="center" />
        </div>
        <div className="le3" onClick={() => handleSelecionarParte("le3")}>
          <img src={SC} id="le3" alt="Imagem 3" className="center" />
        </div>
        <div className="lf3" onClick={() => handleSelecionarParte("lf3")}>
          <img src={SC} id="lf3" alt="Imagem 3" className="center" />
        </div>
        <div className="lg3" onClick={() => handleSelecionarParte("lg3")}>
          <img src={SC} id="lg3" alt="Imagem 3" className="center" />
        </div>
        <div className="lh3" onClick={() => handleSelecionarParte("lh3")}>
          <img src={SC} id="lh3" alt="Imagem 3" className="center" />
        </div>
        <div className="li3" onClick={() => handleSelecionarParte("li3")}>
          <img src={SC} id="li3" alt="Imagem 3" className="center" />
        </div>
        <div className="lj3" onClick={() => handleSelecionarParte("lj3")}>
          <img src={SC} id="lj3" alt="Imagem 3" className="center" />
        </div>
        <div className="lk3" onClick={() => handleSelecionarParte("lk3")}>
          <img src={SC} id="lk3" alt="Imagem 3" className="center" />
        </div>
        <div className="lm3" onClick={() => handleSelecionarParte("lm3")}>
          <img src={SC} id="lm3" alt="Imagem 3" className="center" />
        </div>


        {/** -- Classe terminando com 4 */}
        <div className="la4" onClick={() => handleSelecionarParte("la4")}>
          <img src={SE} id="la4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="lb4" onClick={() => handleSelecionarParte("lb4")}>
          <img src={SEr} id="lb4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="lc4" onClick={() => handleSelecionarParte("lc4")}>
          <img src={SE} id="lc4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="ld4" onClick={() => handleSelecionarParte("ld4")}>
          <img src={SEr} id="ld4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="le4" onClick={() => handleSelecionarParte("le4")}>
          <img src={SE} id="le4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="lf4" onClick={() => handleSelecionarParte("lf4")}>
          <img src={SEr} id="lf4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="lg4" onClick={() => handleSelecionarParte("lg4")}>
          <img src={SE} id="lg4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="lh4" onClick={() => handleSelecionarParte("lh4")}>
          <img src={SEr} id="lh4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="li4" onClick={() => handleSelecionarParte("li4")}>
          <img src={SE} id="li4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="lj4" onClick={() => handleSelecionarParte("lj4")}>
          <img src={SEr} id="lj4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="lk4" onClick={() => handleSelecionarParte("lk4")}>
          <img src={SE} id="lk4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>
        <div className="lm4" onClick={() => handleSelecionarParte("lm4")}>
          <img src={SEr} id="lm4" alt="Imagem 4" width="30" height="30" className="center" />
        </div>


        {/**-- Classe terminando com 5 */}
        <div className="la5" onClick={() => handleSelecionarParte("la5")}>
          <img src={SI} id="la5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lb5" onClick={() => handleSelecionarParte("lb5")}>
          <img src={SIr} id="lb5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lc5" onClick={() => handleSelecionarParte("lc5")}>
          <img src={SI} id="lc5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="ld5" onClick={() => handleSelecionarParte("ld5")}>
          <img src={SIr} id="ld5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="le5" onClick={() => handleSelecionarParte("le5")}>
          <img src={SI} id="le5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lf5" onClick={() => handleSelecionarParte("lf5")}>
          <img src={SIr} id="lf5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lg5" onClick={() => handleSelecionarParte("lg5")}>
          <img src={SI} id="lg5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lh5" onClick={() => handleSelecionarParte("lh5")}>
          <img src={SIr} id="lh5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="li5" onClick={() => handleSelecionarParte("li5")}>
          <img src={SI} id="li5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lj5" onClick={() => handleSelecionarParte("lj5")}>
          <img src={SIr} id="lj5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lk5" onClick={() => handleSelecionarParte("lk5")}>
          <img src={SI} id="lk5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>
        <div className="lm5" onClick={() => handleSelecionarParte("lm5")}>
          <img src={SIr} id="lm5" alt="Imagem 1" width="30" height="30" className="center" />
        </div>

      </div>

      


      <div className="containerR2" style={{
    border: '2px solid black',
    borderRadius: '12px',
    padding: '16px',
     
    margin: '10px auto',
    boxShadow: '2px 2px 10px rgba(0,0,0,0.1)',
    maxWidth: '1300px'
  }}>
        



        <div className="Parte11" id="Parte11" onClick={() => handleSelecionarParte("Parte11")}></div>
<div className="Parte10" id="Parte10" onClick={() => handleSelecionarParte("Parte10")}></div>
<div className="Parte9" id="Parte9" onClick={() => handleSelecionarParte("Parte9")}></div>
<div className="Parte8" id="Parte8" onClick={() => handleSelecionarParte("Parte8")}></div>
<div className="Parte7" id="Parte7" onClick={() => handleSelecionarParte("Parte7")}></div>
<div className="Parte6" id="Parte6" onClick={() => handleSelecionarParte("Parte6")}></div>
<div className="Parte5" id="Parte5" onClick={() => handleSelecionarParte("Parte5")}></div>
<div className="Parte4" id="Parte4" onClick={() => handleSelecionarParte("Parte4")}></div>
<div className="Parte3" id="Parte3" onClick={() => handleSelecionarParte("Parte3")}></div>
<div className="Parte2" id="Parte2" onClick={() => handleSelecionarParte("Parte2")}></div>
<div className="Parte1" id="Parte1" onClick={() => handleSelecionarParte("Parte1")}> </div>

     {/*   <div className="Parte12" id="Parte12" onClick={() => handleSelecionarParte("Parte12")}></div>
        <div className="Parte13" id="Parte13" onClick={() => handleSelecionarParte("Parte13")}></div>
        <div className="Parte14" id="Parte14" onClick={() => handleSelecionarParte("Parte14")}></div>
        <div className="Parte15" id="Parte15" onClick={() => handleSelecionarParte("Parte15")}></div>
        <div className="Parte16" id="Parte16" onClick={() => handleSelecionarParte("Parte16")}></div>
        <div className="Parte17" id="Parte17" onClick={() => handleSelecionarParte("Parte17")}></div>
        <div className="Parte18" id="Parte18" onClick={() => handleSelecionarParte("Parte18")}></div> */}
       <div className="Parte29" id="Parte29" onClick={() => handleSelecionarParte("Parte29")}></div>
<div className="Parte28" id="Parte28" onClick={() => handleSelecionarParte("Parte28")}></div>
<div className="Parte27" id="Parte27" onClick={() => handleSelecionarParte("Parte27")}></div>
<div className="Parte26" id="Parte26" onClick={() => handleSelecionarParte("Parte26")}></div>
<div className="Parte25" id="Parte25" onClick={() => handleSelecionarParte("Parte25")}></div>
<div className="Parte24" id="Parte24" onClick={() => handleSelecionarParte("Parte24")}></div>
<div className="Parte23" id="Parte23" onClick={() => handleSelecionarParte("Parte23")}></div>
<div className="Parte22" id="Parte22" onClick={() => handleSelecionarParte("Parte22")}></div>
<div className="Parte21" id="Parte21" onClick={() => handleSelecionarParte("Parte21")}></div>
<div className="Parte20" id="Parte20" onClick={() => handleSelecionarParte("Parte20")}></div>
<div className="Parte19" id="Parte19" onClick={() => handleSelecionarParte("Parte19")}></div>

   {/*     <div className="Parte30" id="Parte30" onClick={() => handleSelecionarParte("Parte30")}></div>
        <div className="Parte31" id="Parte31" onClick={() => handleSelecionarParte("Parte31")}></div>
        <div className="Parte32" id="Parte32" onClick={() => handleSelecionarParte("Parte32")}></div>
        <div className="Parte33" id="Parte33" onClick={() => handleSelecionarParte("Parte33")}></div>
        <div className="Parte34" id="Parte34" onClick={() => handleSelecionarParte("Parte34")}></div>
        <div className="Parte35" id="Parte35" onClick={() => handleSelecionarParte("Parte35")}></div>
        <div className="Parte36" id="Parte36" onClick={() => handleSelecionarParte("Parte36")}></div>*/}
        <div className="Parte47" id="Parte47" onClick={() => handleSelecionarParte("Parte47")}></div>
<div className="Parte46" id="Parte46" onClick={() => handleSelecionarParte("Parte46")}></div>
<div className="Parte45" id="Parte45" onClick={() => handleSelecionarParte("Parte45")}></div>
<div className="Parte44" id="Parte44" onClick={() => handleSelecionarParte("Parte44")}></div>
<div className="Parte43" id="Parte43" onClick={() => handleSelecionarParte("Parte43")}></div>
<div className="Parte42" id="Parte42" onClick={() => handleSelecionarParte("Parte42")}></div>
<div className="Parte41" id="Parte41" onClick={() => handleSelecionarParte("Parte41")}></div>
<div className="Parte40" id="Parte40" onClick={() => handleSelecionarParte("Parte40")}></div>
<div className="Parte39" id="Parte39" onClick={() => handleSelecionarParte("Parte39")}></div>
<div className="Parte38" id="Parte38" onClick={() => handleSelecionarParte("Parte38")}></div>
<div className="Parte37" id="Parte37" onClick={() => handleSelecionarParte("Parte37")}></div>

     {/*   <div className="Parte48" id="Parte48" onClick={() => handleSelecionarParte("Parte48")}></div>
        <div className="Parte49" id="Parte49" onClick={() => handleSelecionarParte("Parte49")}></div>
        <div className="Parte50" id="Parte50" onClick={() => handleSelecionarParte("Parte50")}></div>
        <div className="Parte51" id="Parte51" onClick={() => handleSelecionarParte("Parte51")}></div>
        <div className="Parte52" id="Parte52" onClick={() => handleSelecionarParte("Parte52")}></div>
        <div className="Parte53" id="Parte53" onClick={() => handleSelecionarParte("Parte53")}></div>
        <div className="Parte54" id="Parte54" onClick={() => handleSelecionarParte("Parte54")}></div> */}
       <div className="Parte65" id="Parte65" onClick={() => handleSelecionarParte("Parte65")}></div>
<div className="Parte64" id="Parte64" onClick={() => handleSelecionarParte("Parte64")}></div>
<div className="Parte63" id="Parte63" onClick={() => handleSelecionarParte("Parte63")}></div>
<div className="Parte62" id="Parte62" onClick={() => handleSelecionarParte("Parte62")}></div>
<div className="Parte61" id="Parte61" onClick={() => handleSelecionarParte("Parte61")}></div>
<div className="Parte60" id="Parte60" onClick={() => handleSelecionarParte("Parte60")}></div>
<div className="Parte59" id="Parte59" onClick={() => handleSelecionarParte("Parte59")}></div>
<div className="Parte58" id="Parte58" onClick={() => handleSelecionarParte("Parte58")}></div>
<div className="Parte57" id="Parte57" onClick={() => handleSelecionarParte("Parte57")}></div>
<div className="Parte56" id="Parte56" onClick={() => handleSelecionarParte("Parte56")}></div>
<div className="Parte55" id="Parte55" onClick={() => handleSelecionarParte("Parte55")}></div>

     {/*    <div className="Parte66" id="Parte66" onClick={() => handleSelecionarParte("Parte66")}></div>
        <div className="Parte67" id="Parte67" onClick={() => handleSelecionarParte("Parte67")}></div>
        <div className="Parte68" id="Parte68" onClick={() => handleSelecionarParte("Parte68")}></div>
        <div className="Parte69" id="Parte69" onClick={() => handleSelecionarParte("Parte69")}></div>
        <div className="Parte70" id="Parte70" onClick={() => handleSelecionarParte("Parte70")}></div>
        <div className="Parte71" id="Parte71" onClick={() => handleSelecionarParte("Parte71")}></div>
        <div className="Parte72" id="Parte72" onClick={() => handleSelecionarParte("Parte72")}></div>*/}
        <div className="Parte83" id="Parte83" onClick={() => handleSelecionarParte("Parte83")}></div>
<div className="Parte82" id="Parte82" onClick={() => handleSelecionarParte("Parte82")}></div>
<div className="Parte81" id="Parte81" onClick={() => handleSelecionarParte("Parte81")}></div>
<div className="Parte80" id="Parte80" onClick={() => handleSelecionarParte("Parte80")}></div>
<div className="Parte79" id="Parte79" onClick={() => handleSelecionarParte("Parte79")}></div>
<div className="Parte78" id="Parte78" onClick={() => handleSelecionarParte("Parte78")}></div>
<div className="Parte77" id="Parte77" onClick={() => handleSelecionarParte("Parte77")}></div>
<div className="Parte76" id="Parte76" onClick={() => handleSelecionarParte("Parte76")}></div>
<div className="Parte75" id="Parte75" onClick={() => handleSelecionarParte("Parte75")}></div>
<div className="Parte74" id="Parte74" onClick={() => handleSelecionarParte("Parte74")}></div>
<div className="Parte73" id="Parte73" onClick={() => handleSelecionarParte("Parte73")}></div>

      {/*   <div className="Parte84" id="Parte84" onClick={() => handleSelecionarParte("Parte84")}></div>
        <div className="Parte85" id="Parte85" onClick={() => handleSelecionarParte("Parte85")}></div>
        <div className="Parte86" id="Parte86" onClick={() => handleSelecionarParte("Parte86")}></div>
        <div className="Parte87" id="Parte87" onClick={() => handleSelecionarParte("Parte87")}></div>
        <div className="Parte88" id="Parte88" onClick={() => handleSelecionarParte("Parte88")}></div>
        <div className="Parte89" id="Parte89" onClick={() => handleSelecionarParte("Parte89")}></div>
        <div className="Parte90" id="Parte90" onClick={() => handleSelecionarParte("Parte90")}></div>*/}
    {/*    <div className="Parte142" id="Parte142" onClick={() => handleSelecionarParte("Parte142")}></div>
        <div className="Parte140" id="Parte140" onClick={() => handleSelecionarParte("Parte140")}></div> */}
        <div className="AAAA"></div>
        <div className="AAAAAAA"></div>
        <div className="AA"></div>
        <div className="AAA"></div>
        <div className="BBB"></div>
        <div className="B"></div>
        <div className="BB"></div>
        <div className="aaaaaaa"></div>
        <div className="aaaaaaaaaaa"></div>
        <div className="Parte141" id="Parte141" onClick={() => handleSelecionarParte("Parte141")}></div>
        <div className="AAAAAAAA"></div>
        <div className="AAAAAAAAAAAAAAAAA"></div>
    {/*    <div className="Parte139" id="Parte139" onClick={() => handleSelecionarParte("Parte139")}></div> */}
        <div className="aaaaaaaa"></div>
      </div>

      <br />

      <div className="containerInfo" style={{
    border: '2px solid #ccc',
    borderRadius: '12px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    margin: '10px auto',
    boxShadow: '2px 2px 10px rgba(0,0,0,0.1)',
    maxWidth: '1300px'
  }} >
          <div className="Info1"> <p>  Informações Complementares: {informacoesEspecificas}   </p>   </div>
          <div className="Info2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>




            <TextField
              id="informaespecifica"
              label="Digite:"
              placeholder="Digite o texto aqui"
              multiline
              variant="standard" sx={{ width: '1000px' }}
              value={infoEspe} // A vinculação com o estado
              onChange={(e) => setInfoEspe(e.target.value)}
            />

          </div>
        </div>

      <div className="containerR3" style={{
    border: '2px solid #ccc',
    borderRadius: '12px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    margin: '10px auto',
    boxShadow: '2px 2px 10px rgba(0,0,0,0.1)',
    maxWidth: '1300px'
  }}>
        <div className="f1">

          <p> <b>Trincas: </b></p>

        </div>
        <div className="f2">
          <p> <b> Corrosão: </b></p>
        </div>
        <div className="f3">
          <p> <b>Poros: </b></p>
        </div>
        <div className="f4">
          <p> <b> Abaulamentos : </b></p>
        </div>
{/*
        <div className="f6">
         

         <p> <b>Foto: </b></p>
        </div> */}
        <div className="f7"> <img src={Trinca} alt="Imagem 1" width="90" height="90" onClick={() => handleTrinca("Trinca")} /> </div>
        <div className="f8"> <img src={Corrosao} alt="Imagem 1" width="90" height="90" onClick={() => handleCorrosao("Corrosao")} /></div>
        <div className="f9"> <img src={Poros} alt="Imagem 1" width="90" height="90" onClick={() => handlePoros("Poros")} /></div>
        <div className="f10"> <img src={Abaulamentos} alt="Imagem 1" width="90" height="90" onClick={() => handleAbaulamento("Abaulamentos")} /></div>








    {/*     <div className="f12"><img src={"foto.png"} alt="Imagem 1" width="90" height="90" className="center" /></div> */}

      </div>


      <div>
        <br />

        
        <div
  style={{
    border: '2px solid #ccc',
    borderRadius: '12px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    margin: '10px auto',
    boxShadow: '2px 2px 10px rgba(0,0,0,0.1)',
    maxWidth: '1300px'
  }}
>
<FormControl
  component="fieldset"
  sx={{
    m: 1,
    p: 1,
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '40px',
    flexWrap: 'wrap',
    justifyContent: 'flex-start'   // ← alinha todos os filhos à esquerda
  }}
>
  {/* Status da Rosca */}
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <FormLabel
      component="legend"
      style={{
        color: 'black',
        fontWeight: 'bold',
        marginBottom: '8px'
      }}
    >
      Status da Rosca:
    </FormLabel>
    <RadioGroup
      aria-label="rosca"
      name="rosca"
      value={selectedValue}
      onChange={handleChange}
      style={{ flexDirection: 'row' }}
    >
      <FormControlLabel value="antiga" control={<Radio />} label="Antiga" />
      <FormControlLabel value="nova"   control={<Radio />} label="Nova"   />
    </RadioGroup>
  </div>

  {/* Acesso ao Relatório GreenDocs alinhado à esquerda */}
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: '8px'             // ← valor válido no gap
  }}>
    <TextField
      id="Green"
      label="Acesso ao Relatório GreenDocs"
      onChange={handleURL}
      variant="outlined"
      sx={{ width: 600 }}
    />
    <img
      id="Green1"
      src={GreenNO}
      alt="Ícone GreenDocs"
      width="50"
      height="50"
    />
  </div>

    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
  {/* Data da Inspeção */}
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="pt-br"
      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <DatePicker
        label="Data da Inspeção:"
        format="DD/MM/YYYY"
        value={dataInspecao}
        onChange={(newValue) => setDataInspecao(newValue)}
      />
    </LocalizationProvider>
  </div>

  {/* Acesso à NR-13 GreenDocs */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <TextField
      id="NR13Greendocs"
      label="Acesso à NR-13 GreenDocs"
      onChange={handleURL}
      variant="outlined"
      sx={{ width: 565}}
    />
    <img
      id="Green2"
      src={GreenNO}
      alt="Ícone GreenDocs"
      width="50"
      height="50"
    />
  </div>
</div>
<div
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      style={{
        border: dragActive ? '2px dashed #1976d2' : '2px dashed #ccc',
        borderRadius: 8,
        padding: 20,
        textAlign: 'center',
        color: dragActive ? '#1976d2' : '#666',
        backgroundColor: dragActive ? '#3dcd23' : '#feff0f',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
      }}
    >
      {mostraTextoSolte ? 'Solte o PNG aqui' : 'Arraste a imagem aqui'}
    </div>


  </FormControl>
</div>



 
 

  
 

       
      </div>
      
      
 
    <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
  {/* Helicóide 1 */}
  <div
    style={{
      border: '2px solid #ccc',
      borderRadius: '12px',
      padding: '16px',
      backgroundColor: '#f9f9f9',
      maxWidth: '400px',
      margin: 'auto',
      boxShadow: '2px 2px 10px rgba(0,0,0,0.1)'
    }}
  >
    <label
      style={{
        display: 'block',
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold',
        marginBottom: '8px'
      }}
    >
      Dados de Inspeção: Helicóide 1
    </label>

    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: 'rgb(76, 232, 232)', textAlign: 'center' }}>
            {headers.map((header, index) => (
              <TableCell key={index} align="center">{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {helicoide1Data.valores.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <TableCell key={cellIndex} align="center">
                  <TextField
                    type="number"
                    value={cell}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value);
                      if (value > 0 && value <= 15) {
                        handleCellChangeHel1(rowIndex, cellIndex, value.toString());
                      }
                    }}
                    variant="standard"
                    fullWidth
                    inputProps={{
                      step: "0.1",
                      min: 0.1,
                      max: 15,
                      style: { textAlign: 'center' }
                    }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </div>

  {/* Helicóide 2 */}
  <div
    style={{
      border: '2px solid #ccc',
      borderRadius: '12px',
      padding: '16px',
      backgroundColor: '#f9f9f9',
      maxWidth: '400px',
      margin: '20px auto',
      boxShadow: '2px 2px 10px rgba(0,0,0,0.1)'
    }}
  >
    <label
      style={{
        display: 'block',
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold',
        marginBottom: '8px'
      }}
    >
      Dados de Inspeção: Helicóide 2
    </label>

    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: 'rgb(56, 172, 172)', textAlign: 'center' }}>
            {headers.map((header, index) => (
              <TableCell key={index} align="center">{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {helicoide2Data.valores.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <TableCell key={cellIndex} align="center">
                  <TextField
                    type="number"
                    value={cell}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value);
                      if (value > 0 && value <= 15) {
                        handleCellChangeHel2(rowIndex, cellIndex, value.toString());
                      }
                    }}
                    variant="standard"
                    fullWidth
                    inputProps={{
                      step: "0.1",
                      min: 0.1,
                      max: 15,
                      style: { textAlign: 'center' }
                    }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </div>
 


 {/* Helicóide 3 */}
<div
  style={{
    border: '2px solid #ccc',
    borderRadius: '12px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    maxWidth: '400px',
    margin: '20px auto',
    boxShadow: '2px 2px 10px rgba(0,0,0,0.1)'
  }}
>
  <label
    style={{
      display: 'block',
      textAlign: 'center',
      width: '100%',
      fontWeight: 'bold',
      marginBottom: '8px'
    }}
  >
    Dados de Inspeção: Helicóide 3
  </label>

  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow style={{ backgroundColor: 'rgb(76, 232, 232)', textAlign: 'center' }}>
          {headers.map((header, index) => (
            <TableCell key={index} align="center">{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {helicoide3Data.valores.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <TableCell key={cellIndex} align="center">
                <TextField
                  type="number"
                  value={cell}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    if (value > 0 && value <= 15) {
                      handleCellChangeHel3(rowIndex, cellIndex, value.toString());
                    }
                  }}
                  variant="standard"
                  fullWidth
                  inputProps={{
                    step: "0.1",
                    min: 0.1,
                    max: 15,
                    style: { textAlign: 'center' }
                  }}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
</div>  

  
</div>


   
<div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
 {/* Helicóide 4 */}
<div
  style={{
    border: '2px solid #ccc',
    borderRadius: '12px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    maxWidth: '400px',
    margin: '20px auto',
    boxShadow: '2px 2px 10px rgba(0,0,0,0.1)'
  }}
>
  <label
    style={{
      display: 'block',
      textAlign: 'center',
      width: '100%',
      fontWeight: 'bold',
      marginBottom: '8px'
    }}
  >
    Dados de Inspeção: Helicóide 4
  </label>

  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow style={{ backgroundColor: 'rgb(56, 172, 172)', textAlign: 'center' }}>
          {headers.map((header, index) => (
            <TableCell key={index} align="center">{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {helicoide4Data.valores.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <TableCell key={cellIndex} align="center">
                <TextField
                  type="number"
                  value={cell}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    if (value > 0 && value <= 15) {
                      handleCellChangeHel4(rowIndex, cellIndex, value.toString());
                    }
                  }}
                  variant="standard"
                  fullWidth
                  inputProps={{
                    step: "0.1",
                    min: 0.1,
                    max: 15,
                    style: { textAlign: 'center' }
                  }}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
</div>


 {/* Helicóide 5 */}
<div
  style={{
    border: '2px solid #ccc',
    borderRadius: '12px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    maxWidth: '400px',
    margin: '20px auto',
    boxShadow: '2px 2px 10px rgba(0,0,0,0.1)'
  }}
>
  <label
    style={{
      display: 'block',
      textAlign: 'center',
      width: '100%',
      fontWeight: 'bold',
      marginBottom: '8px'
    }}
  >
    Dados de Inspeção: Helicóide 5
  </label>

  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow style={{ backgroundColor: 'rgb(76, 232, 232)', textAlign: 'center' }}>
          {headers.map((header, index) => (
            <TableCell key={index} align="center">{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {helicoide5Data.valores.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <TableCell key={cellIndex} align="center">
                <TextField
                  type="number"
                  value={cell}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    if (value > 0 && value <= 15) {
                      handleCellChangeHel5(rowIndex, cellIndex, value.toString());
                    }
                  }}
                  variant="standard"
                  fullWidth
                  inputProps={{
                    step: "0.1",
                    min: 0.1,
                    max: 15,
                    style: { textAlign: 'center' }
                  }}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
</div>

{/* Helicóide 6 */}
<div
  style={{
    border: '2px solid #ccc',
    borderRadius: '12px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    maxWidth: '400px',
    margin: '20px auto',
    boxShadow: '2px 2px 10px rgba(0,0,0,0.1)'
  }}
>
  <label
    style={{
      display: 'block',
      textAlign: 'center',
      width: '100%',
      fontWeight: 'bold',
      marginBottom: '8px'
    }}
  >
    Dados de Inspeção: Helicóide 6
  </label>

  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow style={{ backgroundColor: 'rgb(56, 172, 172)', textAlign: 'center' }}>
          {headers.map((header, index) => (
            <TableCell key={index} align="center">{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {helicoide6Data.valores.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <TableCell key={cellIndex} align="center">
                <TextField
                  type="number"
                  value={cell}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    if (value > 0 && value <= 15) {
                      handleCellChangeHel6(rowIndex, cellIndex, value.toString());
                    }
                  }}
                  variant="standard"
                  fullWidth
                  inputProps={{
                    step: "0.1",
                    min: 0.1,
                    max: 15,
                    style: { textAlign: 'center' }
                  }}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
</div>

   
</div>
      

 
 
<div style={{ textAlign: 'center', marginTop: '20px' }}>
  <Button
    id="btnGreen"
    endIcon={<UrlIcon />}
    onClick={handleEnviar}
    variant="contained"
  >
    Salvar
  </Button>
</div>

      

      <div id="arrayList"></div>




    </div>


  );
};

export default Bidimensional;